export default __webpack_public_path__ + "static/media/1.01c3d474.gif";